import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

export default function PropertyCompsEmptyState({ type }) {
  return (
    <div className="property-comps-empty-state">
      <FontAwesomeIcon icon={faExclamationTriangle} />
      <h3>You have not selected any {type} comps</h3>
    </div>
  );
}

PropertyCompsEmptyState.propTypes = {
  type: PropTypes.string,
};
